export type SubscriptionCancellationCycle = {
  billing_period_start?: string | null;
  billing_period_end?: string | null;
  paid_through_date?: string | null;
  cancellation_effective_at?: string | null;
};

const dateOnly = (value?: string | null) => value?.slice(0, 10) || null;

/**
 * Mirrors the server's fail-closed paid-cycle contract. The customer-visible
 * access-end date is never inferred from renewal_date.
 */
export function resolveAuthoritativeCancellationDate(
  cycle: SubscriptionCancellationCycle | null | undefined,
): string | null {
  if (!cycle) return null;
  const start = dateOnly(cycle.billing_period_start);
  const end = dateOnly(cycle.billing_period_end);
  const paidThrough = dateOnly(cycle.paid_through_date);
  const persistedEffective = dateOnly(cycle.cancellation_effective_at);

  if (!start || !end || !paidThrough || start >= end || end !== paidThrough) return null;
  if (persistedEffective && persistedEffective !== end) return null;
  return persistedEffective || end;
}
